import { snapshot } from 'valtio'
import { locationPin } from '../locationPin'

export function getAllLocationPin(immutable: boolean = true) {
  return immutable ? snapshot(locationPin.pins) : locationPin.pins
}
